export default __webpack_public_path__ + "fonts/eb4eac26f07fbaae5f3c218e2154241f.svg";